import { companySignInDTOSchema, completeFederatedSignInDTOSchema, confirmFederatedLinkDTOSchema, completeFederatedSignupDTOSchema, federatedAuthorizeDTOSchema, federatedProvidersDTOSchema, finishFederatedSignupDTOSchema, pendingFederatedSignupDTOSchema, signInMethodsDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const BASE = `${WEB_API_PREFIX}/auth`;
export function createFederationResource(transport) {
    const federated = (provider) => `${BASE}/federated/${encodeURIComponent(provider)}`;
    return {
        async providers() {
            const res = await transport.request({
                method: 'GET',
                path: `${BASE}/federated/providers`,
                schema: dataEnvelopeSchema(federatedProvidersDTOSchema),
            });
            return res.data;
        },
        async start(provider, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/start`,
                body: input,
                schema: dataEnvelopeSchema(federatedAuthorizeDTOSchema),
            });
            return res.data;
        },
        async startInvite(provider, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/invite/start`,
                body: input,
                schema: dataEnvelopeSchema(federatedAuthorizeDTOSchema),
            });
            return res.data;
        },
        async complete(provider, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/complete`,
                body: input,
                schema: dataEnvelopeSchema(completeFederatedSignInDTOSchema),
            });
            return res.data;
        },
        async signInMethods() {
            const res = await transport.request({
                method: 'GET',
                path: `${BASE}/sign-in-methods`,
                schema: dataEnvelopeSchema(signInMethodsDTOSchema),
            });
            return res.data;
        },
        async unlink(provider) {
            await transport.request({
                method: 'DELETE',
                path: `${BASE}/sign-in-methods/${encodeURIComponent(provider)}`,
                schema: z.undefined(),
            });
        },
        async completeSignup(provider, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/signup/complete`,
                body: input,
                schema: dataEnvelopeSchema(completeFederatedSignupDTOSchema),
            });
            return res.data;
        },
        async pendingSignup() {
            const res = await transport.request({
                method: 'GET',
                path: `${BASE}/federated/signup`,
                schema: dataEnvelopeSchema(pendingFederatedSignupDTOSchema),
            });
            return res.data;
        },
        async finishSignup(input) {
            const res = await transport.request({
                method: 'POST',
                path: `${BASE}/federated/signup`,
                body: input,
                schema: dataEnvelopeSchema(finishFederatedSignupDTOSchema),
            });
            return res.data;
        },
        async confirm(provider, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/confirm`,
                body: input,
                schema: dataEnvelopeSchema(confirmFederatedLinkDTOSchema),
            });
            return res.data;
        },
        async resendConfirmation(provider) {
            await transport.request({
                method: 'POST',
                path: `${federated(provider)}/confirm/resend`,
                body: {},
                schema: z.undefined(),
            });
        },
        async startCompanyTest(provider) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/company-test/start`,
                schema: dataEnvelopeSchema(federatedAuthorizeDTOSchema),
            });
            return res.data;
        },
        async completeCompanyTest(provider, input) {
            const res = await transport.request({
                method: 'POST',
                path: `${federated(provider)}/company-test/complete`,
                body: input,
                schema: dataEnvelopeSchema(companySignInDTOSchema),
            });
            return res.data;
        },
    };
}
//# sourceMappingURL=federation.js.map